/*
 * Same Height function
 */
$.fn.sameHeight = function (options) {
    const settings = $.extend({
        iterator: 3,
        selector: '*:not(.cb, .clear)',
    }, options);

    return this.each((i, elements) => {
        const $target = $(elements).find(settings.selector);
        const heights = [];
        let maxHeight = 0;
        let rowNo = 0;

        $target.each(function (ii) {
            if (maxHeight < $(this).height()) {
                maxHeight = $(this).height();
            }

            if (ii && ((ii + 1) % settings.iterator) === 0) {
                heights[rowNo += 1] = maxHeight;
                maxHeight = 0;
            }
        });
        heights[rowNo] = maxHeight;

        rowNo = 0;
        $target.each(function (ii) {
            if (heights[rowNo] <= 0) {
                return;
            }
            $(this).height(heights[rowNo]);

            if (ii && ((ii + 1) % settings.iterator) === 0) {
                rowNo += 1;
            }
        });
    });
};

// function that returns whether or not an element is inside viewport
$.fn.isOnScreen = function () {
    const win = $(window);
    const bounds = this.offset();
    const viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft(),
    };

    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

// function that handle when element in viewport
$.fn.viewportChecker = function ($callbackFunction) {
    const $el = $(this);
    $el.each((index, element) => {
        const checkerFunction = function () {
            if ($(element).isOnScreen() && $(element).data('viewportChecker-executed') !== true) {
                $(element).data('viewportChecker-executed', true);
                $callbackFunction();
            }
        };

        checkerFunction();
        $(window).scroll(() => {
            checkerFunction();
        });
    });
};
